<template>
  <div>
    <!-- Tabs -->
    <el-tabs v-model="activeName" type="border-card">
      <!-- strat -->
      <el-tab-pane label="详细信息" name="first">
        <div class="block">
          <el-button type="info" class="mt20" @click="backCustomerManagement">返回</el-button>
        </div>

        <el-table :data="dataList" border stripe class="mt15">
          <el-table-column prop="Listorder" label="排序" min-width="5%"></el-table-column>
          <el-table-column prop="Info" label="信息" min-width="80%"></el-table-column>
          <el-table-column prop="operation" label="操作" min-width="15%">
            <template v-slot="scope">
              <el-button type="text" size="mini" style="margin-left: 0; margin-right: 6px" @click="clickEdit(scope.row)">修改</el-button>
              <el-button type="text" size="mini" style="margin-left: 0; margin-right: 6px" @click="clickDel(scope.row)">删除</el-button>
            </template>
          </el-table-column>
        </el-table>

        <!-- 分页 -->
        <div class="pages">
          <el-pagination
            @current-change="handleCurrentPageChange"
            :page-size="10"
            layout="total, prev, pager, next, jumper"
            :total="dataListnum"
			:current-page.sync="selectedPageNo">
          </el-pagination>
        </div>
      </el-tab-pane>
      <!-- end -->

      <!-- 添加 start -->
      <el-tab-pane label="添加" name="second">
        <el-form :model="addData" ref="addDataRef" label-width="120px">
          <el-form-item label="信息" class="addAdminForm">
            <el-input v-model="addData.info" placeholder="请输入信息"></el-input>
          </el-form-item>
          <el-form-item class="mt20">
            <el-button type="primary" @click="clickAdd">保存</el-button>
            <el-button type="info" @click="clickreturn">返回</el-button>
          </el-form-item>
        </el-form>
      </el-tab-pane>
      <!-- 添加 end -->

      <!-- 修改 start -->
      <el-tab-pane label="修改" name="three">
        <el-form :model="editData" ref="editDataRef" label-width="120px">
          <el-form-item label="信息" class="addAdminForm">
            <el-input v-model="editData.info" placeholder="请输入信息"></el-input>
          </el-form-item>
          <el-form-item label="排序" class="addAdminForm">
            <el-input v-model="editData.listorder" placeholder="请输入排序"></el-input>
          </el-form-item>
          <el-form-item class="mt20">
            <el-button type="primary" @click="clickModify">保存</el-button>
            <el-button type="info" @click="clickreturn">返回</el-button>
          </el-form-item>
        </el-form>
      </el-tab-pane>
      <!-- 修改 end -->

    </el-tabs>
    <!-- Tabs end -->
  </div>
</template>

<script>
import Vue from 'vue'
import axios from 'axios'
import VueAxios from 'vue-axios'
import Qs from 'qs'
Vue.use(VueAxios, axios)

export default {
  data () {
    return {
      activeName: 'first',
      selectedPageNo: 1,
      dataList: [],
      dataListnum: 0,
      parentid: '',
      addData: {
        info: ''
      },
      editData: {
        id: '',
        info: '',
        listorder:''
      }
    }
  },
  mounted () {
  },
  methods: {
    LoadData (row) {
      this.parentid = row.Id
      this.GetKgjtWebsiteExpertsInfoNum()
      this.GetKgjtWebsiteExpertsInfoList()
    },
    backCustomerManagement () {
      this.$emit('triggerFunc', '')
    },
    handleCurrentPageChange (selectedPageNo) {
      this.GetKgjtWebsiteExpertsInfoList()
    },
    clickreturn () {
      this.activeName = 'first'
    },
    clickAdd () {
      this.AddKgjtWebsiteExpertsInfo()
    },
    clickEdit (row) {
      this.editData.id = row.Id
      this.editData.info = row.Info
      this.editData.listorder = row.Listorder
      this.activeName = 'three'
    },
    clickDel(row){
      this.$confirm('是否删除?', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      }).then(() => {
        this.DelKgjtWebsiteExpertsInfo(row)
      })
    },
    clickModify () {
      this.EditKgjtWebsiteExpertsInfo()
    },
    GetKgjtWebsiteExpertsInfoList: function () {
      var that = this
      var useriderp = localStorage.getItem('Useriderp')
      var timestamp = Date.parse(new Date()) / 1000
      var data = {
        os: 'erp',
        useriderp: useriderp,
        timestamp: timestamp,
        localfingerprint: Vue.prototype.FunGetLocalFingerprint(),
        pageno: that.selectedPageNo,
        parentid: that.parentid
      }
      // 加上签名
      data.sign = Vue.prototype.FunGetSignErp(data)
      axios.post(Vue.prototype.global.Url_GetKgjtWebsiteExpertsInfoList, Qs.stringify(data))
        .then(function (response) {
          if (response.data.Code === 200) {
            that.dataList = response.data.List
          }
          Vue.prototype.FunCheckApiCodeBackground(response.data)
        })
        .catch(function (error) {
          Vue.prototype.FunLogError(error)
        })
    },
    GetKgjtWebsiteExpertsInfoNum: function () {
      var that = this
      var useriderp = localStorage.getItem('Useriderp')
      var timestamp = Date.parse(new Date()) / 1000
      var data = {
        os: 'erp',
        useriderp: useriderp,
        timestamp: timestamp,
        localfingerprint: Vue.prototype.FunGetLocalFingerprint(),
        pageno: that.selectedPageNo,
        parentid: that.parentid
      }
      // 加上签名
      data.sign = Vue.prototype.FunGetSignErp(data)
      axios.post(Vue.prototype.global.Url_GetKgjtWebsiteExpertsInfoNum, Qs.stringify(data))
        .then(function (response) {
          if (response.data.Code === 200) {
            that.dataListnum = response.data.Num
          }
          Vue.prototype.FunCheckApiCodeBackground(response.data)
        })
        .catch(function (error) {
          Vue.prototype.FunLogError(error)
        })
    },
    AddKgjtWebsiteExpertsInfo: function () {
      var that = this
      var useriderp = localStorage.getItem('Useriderp')
      var timestamp = Date.parse(new Date()) / 1000
      var data = {
        os: 'erp',
        useriderp: useriderp,
        timestamp: timestamp,
        localfingerprint: Vue.prototype.FunGetLocalFingerprint(),
        parentid: that.parentid,
        info: that.addData.info
      }
      // 加上签名
      data.sign = Vue.prototype.FunGetSignErp(data)
      axios.post(Vue.prototype.global.Url_AddKgjtWebsiteExpertsInfo, Qs.stringify(data))
        .then(function (response) {
          Vue.prototype.FunCheckApiCodeWithCallback(response.data, true, function () {
            that.activeName = 'first'
            that.GetKgjtWebsiteExpertsInfoNum()
            that.GetKgjtWebsiteExpertsInfoList()
          })
        })
        .catch(function (error) {
          Vue.prototype.FunLogError(error)
        })
    },
    EditKgjtWebsiteExpertsInfo: function () {
      var that = this
      var useriderp = localStorage.getItem('Useriderp')
      var timestamp = Date.parse(new Date()) / 1000
      var data = {
        os: 'erp',
        useriderp: useriderp,
        timestamp: timestamp,
        localfingerprint: Vue.prototype.FunGetLocalFingerprint(),
        parentid: that.parentid,
        id: that.editData.id,
        info: that.editData.info,
        listorder: that.editData.listorder
      }
      // 加上签名
      data.sign = Vue.prototype.FunGetSignErp(data)
      axios.post(Vue.prototype.global.Url_EditKgjtWebsiteExpertsInfo, Qs.stringify(data))
        .then(function (response) {
          Vue.prototype.FunCheckApiCodeWithCallback(response.data, true, function () {
            that.activeName = 'first'
            that.GetKgjtWebsiteExpertsInfoList()
          })
        })
        .catch(function (error) {
          Vue.prototype.FunLogError(error)
        })
    },
    DelKgjtWebsiteExpertsInfo: function (row) {
      var that = this
      var useriderp = localStorage.getItem('Useriderp')
      var timestamp = Date.parse(new Date()) / 1000
      var data = {
        os: 'erp',
        useriderp: useriderp,
        timestamp: timestamp,
        localfingerprint: Vue.prototype.FunGetLocalFingerprint(),
        id: row.Id
      }
      // 加上签名
      data.sign = Vue.prototype.FunGetSignErp(data)
      axios.post(Vue.prototype.global.Url_DelKgjtWebsiteExpertsInfo, Qs.stringify(data))
        .then(function (response) {
          that.GetKgjtWebsiteExpertsInfoNum()
          that.GetKgjtWebsiteExpertsInfoList()
          Vue.prototype.FunCheckApiCode(response.data)
        })
        .catch(function (error) {
          Vue.prototype.FunLogError(error)
        })
    }
  }
}
</script>

<style lang="scss" scoped>

</style>
